import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import ApiKeyCard from "./ApiKeyCard";
import Greetings from "./Greetings";
import NeedHelpCard from "./NeedHelpCard";
import RightSidebar from "./RightSidebar";
import PlanOverviewAndStatsCard from "./PlanOverviewAndStatsCard";
import WhatsNewCard from "./WhatsNewCard";

import MaxWidthPage from "components/MaxWidthPage";
import Page from "components/Page/Page";

import { useContactSales } from "hooks/useContactSales";
import { useSupportWidget } from "hooks/useSupportWidget";

import BorderLayout from "layouts/BorderLayout";

import AiResultsEndpointsWidget from "pages/dashboard/AiResultsEndpointsWidget";
import QuickStartCard from "pages/dashboard/quickstart/QuickStartCard";
import RecentlyViewedCard from "pages/dashboard/RecentlyViewedCard";

import { RecentlyViewedProvider } from "providers/RecentlyViewed/RecentlyViewedProvider";

import { useUser } from "routes/dataroutes/UserData";
import ProductFruitsProvider from "providers/ProductFruitsProvider";


function AutoOpenSupportWidget() {
  const user = useUser();
  const location = useLocation();
  const supportWidget = useSupportWidget();
  const { openSupportWidget, openSalesWidget } = location.state ? location.state as { openSupportWidget: boolean, openSalesWidget: boolean } : { openSupportWidget: false, openSalesWidget: false };
  const { contactSalesFn } = useContactSales();

  useEffect(() => {
    if (openSupportWidget) {
      supportWidget.showSupportForm(user?.email);
    }
    if (openSalesWidget) {
      contactSalesFn();
    }
  }, [ openSupportWidget, openSalesWidget, supportWidget, user?.email, contactSalesFn ]);

  return <></>;
}


export default function DashboardHome() {
  const user = useUser();

  return (
    <ProductFruitsProvider>
      <RecentlyViewedProvider>
        <MaxWidthPage fullWidth>
          <Page
            title={ <Greetings/> }
            browserTitle="Dashboard"
          >
            {/* TODO should also change this one to a simple flex layout */}
            <BorderLayout
              right={
                <div className="hidden _1100:block">
                  <RightSidebar />
                </div>
              }
              scrollMain={ false }
            >
              <AutoOpenSupportWidget />
              <div className="flex flex-col gap-y-6">
                { !user?.isFreeTrial && <RecentlyViewedCard /> }
                { !user?.isFreeTrial && <AiResultsEndpointsWidget /> }
                <ApiKeyCard className="_1100:hidden" />
                { user?.isFreeTrial && <QuickStartCard /> }
                <PlanOverviewAndStatsCard />
                <WhatsNewCard className="_1100:hidden" />
                <NeedHelpCard className="_1100:hidden mb-6" />
              </div>
            </BorderLayout>
          </Page>

          {/* for modal child-routes */}
          <Outlet/>
        </MaxWidthPage>
      </RecentlyViewedProvider>
    </ProductFruitsProvider>
  );
}
